import { ImgOnChangeValue, ImgSelect, ImgSelectProps } from 'imaginarity-react-ui';
import * as _ from "lodash";
import * as React from 'react';
import { useImgI18N } from 'services/ImgI18N';
type ClearableValue<T, IsClearable> = IsClearable extends true ? (T | null) : (T);
type OnChangeValue<T, IsMulti extends boolean, IsClearable extends boolean> = IsMulti extends true ? ClearableValue<T[], IsClearable> : ClearableValue<T, IsClearable>;

interface ArraySelectionProps<IsMulti extends boolean, IsClearable extends boolean> extends Omit<ImgSelectProps<{ value: string, label: string }, IsMulti>, "value" | "onChange" | "isMulti" | "isClearable"> {
    onChange: (value: ImgOnChangeValue<string, IsMulti, IsClearable>) => void;
    array: string[];
    namespace: string;
    isMulti: IsMulti;
    isClearable?: IsClearable;
    value: OnChangeValue<string, IsMulti, IsClearable>;
    dontTranslateValues?: boolean;
}

const ArraySelection = <IsMulti extends boolean = true, IsClearable extends boolean = false>(p: ArraySelectionProps<IsMulti, IsClearable>) => {
    const { array, namespace, isMulti, onChange, value, dontTranslateValues, ...rest } = p;
    const { t } = useImgI18N(namespace);
    const [options, setOptions] = React.useState<Array<{ value: string, label: string }>>([]);

    React.useEffect(() => {
        setOptions(_.map(array, a => ({ value: a, label: dontTranslateValues ? a : t(a) })));
    }, [array, t, dontTranslateValues]);

    const val = React.useMemo(() => _.isArray(value) ? _.filter(options, o => _.find(value, v => v === o.value) !== undefined) : _.find(options, o => o.value === (value as any)), [value, options]);

    const onChg = React.useMemo(() => (newValue: ImgOnChangeValue<{ value: string, label: string }, IsMulti, IsClearable>) => {
        onChange((_.isArray(newValue) ? _.map(newValue, v => v.value) : (newValue ? ((newValue as any).value as any) : null)));
    }, [onChange])

    if (!options)
        return <div />;
    return (
        <ImgSelect
            onChange={onChg}
            options={options}
            value={val}
            isMulti={isMulti}
            {...rest}
        />
    );
}
export default ArraySelection;